import { render, staticRenderFns } from "./InstructionsAboutTest.vue?vue&type=template&id=0ba17bd7&"
import script from "./InstructionsAboutTest.vue?vue&type=script&lang=js&"
export * from "./InstructionsAboutTest.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports